<template>
    <div class="fullwidth">
        <div role="alert" class="alert" :class="alertClass" v-if=showMessage>
            <div class="container">
                <div class="alert-header">
                    <attention class="svg-36 white-svg"></attention>
                    <div class="message-wrapper">
                        <h2 class="pl-3" v-html="displayMessage"></h2>
                    </div>
                    <span class="d-inline-block svg-36 white-svg cursor-pointer" @click.prevent="showMessage = !showMessage">
                      <circle_close class="svg-36 white-svg"></circle_close>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Close from "./icons/close";
  import Attention from "./icons/attention";
  import Circle_close from "./icons/circle_close";

  export default {
      components: {Circle_close, Attention, Close},
      props: ['message'],
        data() {
            return {
                showMessage: (this.message.level) ? true : false,
                alertClass: 'alert-' + this.message.level,
                displayMessage: this.message.message,
            }
        },
        methods: {
          activateFlashAlert: function(messageText, alertLevel) {
            this.showMessage = true;
            this.displayMessage = messageText;
            this.alertClass = 'alert-' + alertLevel
          }
        }
    }
</script>
